import library from './narration-library.json' with {type:'json'};
// Updated by the batch publisher only after packages pass validation.
export const narratedStoryId = 'agents-hugging-face';
export const narratedStoryIds:readonly string[]=library.storyIds;
export function selectedNarrationStory(args:string[]){
 const position=args.indexOf('--story'),id=position<0?narratedStoryId:args[position+1];
 if(!narratedStoryIds.includes(id))throw Error('Choose an authorized narration story with --story');
 return id;
}
export type NarrationStory = {id:string;title:string;contentRevision?:number;slides:{title:string;body:string;ending:string}[]};
export type NarrationManifest = {
 schemaVersion:1;storyId:string;language:'en';contentRevision:number;voice:string;model:string;
 slides:{index:number;textHash:string;file?:string;durationSeconds:number}[];
 track?:NarrationTrack;
};
export type NarrationTrack={file:string;durationSeconds:number;cues:{index:number;startSeconds:number;endSeconds:number}[]};
export function narrationText(story:NarrationStory,index:number){
 const slide=story.slides[index];
 if(!slide)throw Error('Slide unavailable');
 return [index===0?story.title:slide.title,slide.body,slide.ending].filter(Boolean).join('\n\n').normalize('NFC');
}
export function narrationPrefix(story:NarrationStory){
 if(!narratedStoryIds.includes(story.id)||!Number.isSafeInteger(story.contentRevision)||story.contentRevision!<1)return null;
 return `narration/en/${story.id}/r${story.contentRevision}`;
}
export async function narrationHash(text:string){
 const digest=await crypto.subtle.digest('SHA-256',new TextEncoder().encode(text));
 return [...new Uint8Array(digest)].map(value=>value.toString(16).padStart(2,'0')).join('');
}
export function narrationSlide(manifest:unknown,story:NarrationStory,index:number,textHash:string){
 const m=manifest as Partial<NarrationManifest>|null;
 if(!m||m.schemaVersion!==1||m.storyId!==story.id||m.language!=='en'||m.contentRevision!==story.contentRevision||!Array.isArray(m.slides)||m.slides.length!==story.slides.length)return null;
 const slide=m.slides.find(item=>item?.index===index);
 if(!slide||slide.textHash!==textHash||(slide.file!==undefined&&!/^slide-\d+-[a-f0-9]{64}\.mp3$/.test(slide.file))||!(slide.durationSeconds>0))return null;
 return slide;
}
export function narrationTrack(manifest:unknown,story:NarrationStory,textHashes:string[]):NarrationTrack|null{
 const m=manifest as Partial<NarrationManifest>|null,track=m?.track;
 if(!track||!/^story-[a-f0-9]{64}\.mp3$/.test(track.file)||!Number.isFinite(track.durationSeconds)||track.durationSeconds<=0||!Array.isArray(track.cues)||track.cues.length!==story.slides.length||textHashes.length!==story.slides.length)return null;
 let end=0;
 for(let index=0;index<story.slides.length;index++){
  if(!narrationSlide(m,story,index,textHashes[index]))return null;
  const cue=track.cues[index];
  if(!cue||cue.index!==index||!Number.isFinite(cue.startSeconds)||!Number.isFinite(cue.endSeconds)||Math.abs(cue.startSeconds-end)>.001||cue.endSeconds<=cue.startSeconds)return null;
  end=cue.endSeconds;
 }
 return Math.abs(end-track.durationSeconds)<.05?track:null;
}
export function narrationIndexAt(track:NarrationTrack,seconds:number){
 // Media time is commonly rounded to microseconds; PCM cues use 1/24000 s.
 for(let index=track.cues.length-1;index>=0;index--)if(seconds+.00001>=track.cues[index].startSeconds)return index;
 return 0;
}
